<template>
  <div class="wework-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="wework-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>企业微信</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主体布局：左侧内容 + 右侧栏 -->
    <div class="wework-layout">
      <!-- 左侧主内容区 -->
      <div class="wework-main">
        <el-card class="wework-card wework-card-tabs" shadow="hover">
          <el-tabs v-model="activeTab" class="wework-tabs">
            <!-- Tab: 群列表管理 -->
            <el-tab-pane name="groups">
              <span slot="label">
                <i class="el-icon-chat-dot-round"></i> 群列表管理
              </span>
              <div class="tab-toolbar">
                <el-input v-model="groupKeyword" placeholder="搜索群名" size="small" style="width: 220px;"
                          clearable @clear="searchGroups" @keyup.enter.native="searchGroups">
                  <el-button slot="append" icon="el-icon-search" @click="searchGroups"></el-button>
                </el-input>
                <el-button type="primary" size="small" icon="el-icon-refresh" @click="syncGroups" :loading="syncLoading">同步群列表</el-button>
              </div>
              <el-table :data="groupList" border stripe size="small" style="width: 100%" v-loading="groupLoading"
                        :height="tableHeight" class="wework-table">
                <el-table-column prop="nickname" label="群昵称" min-width="200"></el-table-column>
                <el-table-column prop="conversation_id" label="群编号" width="200"></el-table-column>
                <el-table-column prop="total" label="成员数" width="80" align="center"></el-table-column>
                <el-table-column label="群类型" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.is_external === 1 ? 'warning' : 'success'" size="mini">
                      {{ scope.row.is_external === 1 ? '外部群' : '内部群' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="170" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.create_time ? $getDateTime(new Date(scope.row.create_time * 1000)) : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="syncedAt" label="最后同步" width="170" align="center">
                  <template slot-scope="scope">
                    {{ $getDateTime(scope.row.syncedAt) }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @current-change="handleGroupPageChange" :current-page="groupPagenum" :page-size="groupPagesize"
                             :total="groupTotal" layout="total, prev, pager, next" class="wework-pagination">
              </el-pagination>
            </el-tab-pane>

            <!-- Tab: 发送日志 -->
            <el-tab-pane name="logs">
              <span slot="label">
                <i class="el-icon-document"></i> 发送日志
              </span>
              <div class="tab-toolbar">
                <el-input v-model="logFilter.conversationName" placeholder="群名关键词" size="small" style="width: 150px;"
                          clearable @clear="searchLogs" @keyup.enter.native="searchLogs"></el-input>
                <el-input v-model="logFilter.keyword" placeholder="消息内容关键字" size="small" style="width: 170px;"
                          clearable @clear="searchLogs" @keyup.enter.native="searchLogs"></el-input>
                <el-select v-model="logFilter.status" clearable placeholder="状态" size="small" style="width: 110px;" @change="searchLogs">
                  <el-option label="成功" :value="1"></el-option>
                  <el-option label="失败" :value="2"></el-option>
                  <el-option label="队列中" :value="0"></el-option>
                  <el-option label="已重发" :value="3"></el-option>
                </el-select>
                <el-date-picker v-model="logFilter.timeRange" type="datetimerange" size="small" range-separator="至"
                                start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 330px;" :default-time="['00:00:00', '23:59:59']" @change="searchLogs"></el-date-picker>
                <el-button type="primary" size="small" icon="el-icon-search" @click="searchLogs">搜索</el-button>
                <el-button size="small" @click="resetLogFilter">重置</el-button>
              </div>
              <el-table :data="logList" border stripe size="small" style="width: 100%" v-loading="logLoading"
                        :height="tableHeight" class="wework-table">
                <el-table-column prop="sentAt" label="发送时间" width="160" align="center">
                  <template slot-scope="scope">{{ $getDateTime(scope.row.sentAt) }}</template>
                </el-table-column>
                <el-table-column prop="conversationName" label="目标群" width="180"></el-table-column>
                <el-table-column prop="content" label="消息内容" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : scope.row.status === 3 ? 'info' : 'warning'" size="mini">
                      {{ scope.row.status === 1 ? '成功' : scope.row.status === 2 ? '失败' : scope.row.status === 3 ? '已重发' : '队列中' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="sentBy" label="发送人" width="100" align="center"></el-table-column>
                <el-table-column prop="errorMessage" label="错误信息" width="200" show-overflow-tooltip></el-table-column>
              </el-table>
              <el-pagination @current-change="handleLogPageChange" :current-page="logPagenum" :page-size="logPagesize"
                             :total="logTotal" layout="total, prev, pager, next" class="wework-pagination">
              </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>

      <!-- 右侧栏 -->
      <div class="wework-sidebar">
        <!-- 采集端配置提示 -->
        <el-card class="wework-card sidebar-card" shadow="hover">
          <div style="font-size:13px;color:#909399;line-height:1.8;">
            <i class="el-icon-info" style="color:#409eff;margin-right:4px;"></i>
            采集端配置请前往
            <el-link type="primary" href="#/yunwei/collector">采集端管理</el-link>
          </div>
        </el-card>

        <!-- 登录账号信息 -->
        <el-card class="wework-card sidebar-card" shadow="hover">
          <div slot="header" class="sidebar-card-header">
            <i class="el-icon-user"></i>
            <span>登录账号</span>
            <el-button type="text" size="mini" @click="getAccountInfo" :loading="accountLoading" style="margin-left: auto;">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>
          <div v-if="accountInfo" class="account-info">
            <div class="account-field">
              <label>账号id</label><span>{{ accountInfo.acctid || '--' }}</span>
            </div>
            <div class="account-field">
              <label>用户名</label><span>{{ accountInfo.username || '--' }}</span>
            </div>
            <div class="account-field">
              <label>用户id</label><span>{{ accountInfo.user_id || '--' }}</span>
            </div>
            <div class="account-field">
              <label>公司</label><span>{{ accountInfo.corp_short_name || '--' }}</span>
            </div>
            <div class="account-field">
              <label>公司id</label><span>{{ accountInfo.corp_id || '--' }}</span>
            </div>
          </div>
          <el-empty v-else description="点击刷新获取账号信息" :image-size="50"></el-empty>
        </el-card>

        <!-- 发送消息 -->
        <el-card class="wework-card sidebar-card" shadow="hover">
          <div slot="header" class="sidebar-card-header">
            <i class="el-icon-s-promotion"></i>
            <span>发送消息</span>
          </div>
          <el-form label-width="60px" size="small" class="sidebar-form">
            <el-form-item label="选择群">
              <el-select v-model="msgForm.conversation_id" filterable placeholder="请选择群" style="width: 100%;">
                <el-option v-for="g in allGroupsForSelect" :key="g.conversation_id" :label="g.nickname" :value="g.conversation_id">
                  <span>{{ g.nickname }}</span>
                  <span style="color: #999; margin-left: 8px; font-size: 12px;">({{ g.total }}人)</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容">
              <el-input v-model="msgForm.content" type="textarea" :rows="4" placeholder="请输入消息内容" maxlength="2000" show-word-limit></el-input>
            </el-form-item>
            <div class="sidebar-actions">
              <el-button type="primary" @click="sendMessage" :loading="sendLoading"
                         :disabled="!msgForm.conversation_id || !msgForm.content" size="small" style="width: 100%;">
                <i class="el-icon-s-promotion"></i> 发送
              </el-button>
            </div>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'groups',

      // 账号信息
      accountInfo: null,
      accountLoading: false,

      // 群列表
      groupList: [],
      allGroupsForSelect: [], // 发送消息用全量群列表（不限分页）
      groupTotal: 0,
      groupPagenum: 1,
      groupPagesize: 20,
      groupKeyword: '',
      groupLoading: false,
      syncLoading: false,

      // 发送消息
      msgForm: { conversation_id: '', content: '' },
      sendLoading: false,

      // 发送日志
      logList: [],
      logTotal: 0,
      logPagenum: 1,
      logPagesize: 15,
      logFilter: { conversationName: '', keyword: '', status: '', timeRange: null },
      logLoading: false
    }
  },
  computed: {
    tableHeight () {
      // 根据窗口高度动态计算表格高度，减去顶部占用空间
      return window.innerHeight - 280
    }
  },
  created () {
    this.loadGroups()
    this.loadAllGroupsForSelect()
    this.loadLogs()
  },
  methods: {
    // 获取账号信息
    async getAccountInfo () {
      this.accountLoading = true
      try {
        const { data: res } = await this.$http.get('yunwei/wework/account')
        if (res.meta.status === 200) {
          this.accountInfo = res.data
        } else {
          this.$message.error(res.meta.msg || '获取账号信息失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.accountLoading = false
    },
    // 加载群列表（分页）
    async loadGroups () {
      this.groupLoading = true
      try {
        const params = { pagenum: this.groupPagenum, pagesize: this.groupPagesize }
        if (this.groupKeyword) params.keyword = this.groupKeyword
        const { data: res } = await this.$http.get('yunwei/wework/groups', { params })
        if (res.meta.status === 200) {
          this.groupList = res.data.list || []
          this.groupTotal = res.data.total || 0
        }
      } catch (e) { /* 忽略 */ }
      this.groupLoading = false
    },
    // 加载全量群列表（用于发送消息的群选择，不分页）
    async loadAllGroupsForSelect () {
      try {
        const { data: res } = await this.$http.get('yunwei/wework/allGroups')
        if (res.meta.status === 200) {
          this.allGroupsForSelect = res.data.list || []
        }
      } catch (e) { /* 忽略 */ }
    },
    searchGroups () {
      this.groupPagenum = 1
      this.loadGroups()
    },
    handleGroupPageChange (val) {
      this.groupPagenum = val
      this.loadGroups()
    },
    // 同步群列表
    async syncGroups () {
      this.syncLoading = true
      try {
        const { data: res } = await this.$http.post('yunwei/wework/syncGroups')
        if (res.meta.status === 200) {
          this.$message.success(`同步完成，共处理 ${res.data.synced} 个群`)
          this.loadGroups()
          this.loadAllGroupsForSelect()
        } else {
          this.$message.error(res.meta.msg || '同步失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.syncLoading = false
    },
    // 发送消息
    async sendMessage () {
      if (!this.msgForm.conversation_id || !this.msgForm.content) {
        return this.$message.warning('请选择群并输入消息内容')
      }
      this.sendLoading = true
      try {
        const { data: res } = await this.$http.post('yunwei/wework/sendMessage', this.msgForm)
        if (res.meta.status === 200) {
          this.$message.success('已加入推送队列，将在数秒内发送，可在推送监控页查看结果')
          this.msgForm.content = ''
          this.loadLogs()
        } else {
          this.$message.error(res.meta.msg || '入队失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.sendLoading = false
    },
    // 加载日志
    async loadLogs () {
      this.logLoading = true
      try {
        const params = { pagenum: this.logPagenum, pagesize: this.logPagesize }
        if (this.logFilter.conversationName && this.logFilter.conversationName.trim()) params.conversationName = this.logFilter.conversationName.trim()
        if (this.logFilter.keyword && this.logFilter.keyword.trim()) params.keyword = this.logFilter.keyword.trim()
        if (this.logFilter.status !== '' && this.logFilter.status !== null) params.status = this.logFilter.status
        if (this.logFilter.timeRange && this.logFilter.timeRange.length === 2) {
          params.startTime = this.logFilter.timeRange[0]
          params.endTime = this.logFilter.timeRange[1]
        }
        const { data: res } = await this.$http.get('yunwei/wework/messageLogs', { params })
        if (res.meta.status === 200) {
          this.logList = res.data.list || []
          this.logTotal = res.data.total || 0
        }
      } catch (e) { /* 忽略 */ }
      this.logLoading = false
    },
    searchLogs () {
      this.logPagenum = 1
      this.loadLogs()
    },
    resetLogFilter () {
      this.logFilter = { conversationName: '', keyword: '', status: '', timeRange: null }
      this.searchLogs()
    },
    handleLogPageChange (val) {
      this.logPagenum = val
      this.loadLogs()
    }
  }
}
</script>

<style scoped>
.wework-page {
  padding: 0 4px;
}

.wework-breadcrumb {
  margin-bottom: 16px;
}

/* ========== 主布局：左右分栏 ========== */
.wework-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.wework-main {
  flex: 1;
  min-width: 0;
}

.wework-sidebar {
  width: 360px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ========== 卡片样式 ========== */
.wework-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.wework-card-tabs {
  min-height: calc(100vh - 180px);
}

.wework-card-tabs >>> .el-card__body {
  padding: 0 20px 20px;
}

/* ========== Tab 样式 ========== */
.wework-tabs >>> .el-tabs__header {
  margin-bottom: 0;
  padding-top: 4px;
}

.wework-tabs >>> .el-tabs__item {
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  font-weight: 500;
}

.wework-tabs >>> .el-tabs__item i {
  margin-right: 4px;
}

.wework-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
}

/* ========== Tab 工具栏 ========== */
.tab-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0 12px;
}

/* ========== 表格 ========== */
.wework-pagination {
  padding: 14px 0 0;
  text-align: right;
}

/* ========== 右侧栏卡片 ========== */
.sidebar-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.sidebar-card >>> .el-card__header {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.sidebar-card >>> .el-card__body {
  padding: 16px;
}

.sidebar-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.sidebar-card-header i {
  font-size: 16px;
  color: #409eff;
}

.sidebar-form >>> .el-form-item {
  margin-bottom: 12px;
}

.sidebar-form >>> .el-form-item__label {
  font-size: 13px;
  color: #606266;
}

.sidebar-actions {
  display: flex;
  gap: 8px;
  padding-top: 4px;
}

/* ========== 账号信息 ========== */
.account-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-field {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  line-height: 1.5;
}

.account-field label {
  flex-shrink: 0;
  width: 56px;
  color: #909399;
  text-align: right;
  margin-right: 8px;
  font-weight: 500;
}

.account-field span {
  color: #303133;
  word-break: break-all;
}
</style>
